// eslint-disable-next-line import/prefer-default-export
export const getBrandTheme = (state) => state.ThemeReducer.theme;
export const getBrandName = (state) => state.ThemeReducer.brandName;
export const getBrandUrl = (state) => state.ThemeReducer.brandUrl;
export const getBrandTitle = (state) => state.ThemeReducer.title;
export const getBrandResourceUrl = (state) => state.ThemeReducer.resourceUrl;
export const getThemeData = (state) => state.ThemeReducer;
